import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsPauseIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M7.36 4.92H9.36V19H7.36V4.92ZM14.64 4.92H16.64V19H14.64V4.92Z" />
    </SvgIcon>
  );
});
